module.exports = __webpack_public_path__ + "img/c22e988.gif";